// AssessLanding.js
import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import styles from "./AssessLanding.module.css";

export default function AssessLanding() {
  const navigate = useNavigate();

  return (
    <div>
      <Header />
      
        <div className={styles.page}>
          <div className={styles.container}>
            
            <p className={styles.topLine}>
              Choose your choice of assessment mode from below:
            </p>

            <div className={styles.card}>
              <h2 className={styles.cardTitle}>Full Assessment</h2>

              <ul className={styles.list}>
                <li
                  className={styles.clickableItem}
                  onClick={() => navigate('/assess/full/ancient-couplet')}
                >
                  Ancient Style Couplet
                </li>
                <li
                  className={styles.clickableItem}
                  onClick={() => navigate('/assess/full/ancient-jueju')}
                >
                  Ancient Style Jueju
                </li>

                <li
                  className={styles.clickableItem}
                  onClick={() => navigate('/assess/pingze/regulated-couplet')}
                >
                  Regulated Couplet
                </li>

                <li
                  className={styles.clickableItem}
                  onClick={() => navigate('/assess/pingze/regulated-jueju')}
                >
                  Regulated Jueju
                </li>

              </ul>

            </div>

            <div className={styles.card}>
              <h2 className={styles.cardTitle}>Limited Ping/Ze Pattern Assessment</h2>

              <ul className={styles.list}>
                <li
                  className={styles.clickableItem}
                  onClick={() => navigate('/assess/pingze/regulated-couplet')}
                >
                  Regulated Couplet
                </li>

                <li
                  className={styles.clickableItem}
                  onClick={() => navigate('/assess/pingze/regulated-jueju')}
                >
                  Regulated Jueju
                </li>

              </ul>

            </div>
          </div>
        </div>
    </div>
  );
}
